import transactionHistoryTypes from './types';

const initialState = {
  transactionHistory: {
    data: [],
  },
  fetchingtransactionHistory: true,
  isQueryingStatus: false,
  isExpotingData: false,
  error: null,
};

function transactionHistoryReducer(state = initialState, { type, payload }) {
  switch (type) {
    case transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_START:
      return {
        ...state,
        fetchingtransactionHistory: true,
      };
    case transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_SUCCESS:
      return {
        ...state,
        fetchingtransactionHistory: false,
        transactionHistory: payload,
      };
    case transactionHistoryTypes.FETCH_TRANSACTIONS_HISTORY_FAILURE:
      return {
        ...state,
        fetchingtransactionHistory: false,
        error: payload,
      };
    case transactionHistoryTypes.QUERY_TRANSACTION_START:
      return {
        ...state,
        isQueryingStatus: true,
      };
    case transactionHistoryTypes.QUERY_TRANSACTION_SUCCESS:
      const transactionsClone = [...state.transactionHistory.data];
      transactionsClone.forEach((transaction) => {
        if (transaction.reference === payload.transactionRef) {
          transaction.status = payload.status;
        }
      });
      return {
        ...state,
        isQueryingStatus: false,
        transactionHistory: {
          ...state.transactionHistory,
          data: [...transactionsClone],
        },
      };

    case transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_START:
      return {
        ...state,
        isQueryingStatus: true,
      };
    case transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isQueryingStatus: false,
      };
    case transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_FAILURE:
      return {
        ...state,
        isQueryingStatus: false,
        error: payload,
      };

    case transactionHistoryTypes.EXPORT_TRANSACTION_START:
      return {
        ...state,
        isExpotingData: true,
      };
    case transactionHistoryTypes.EXPORT_TRANSACTION_SUCCESS:
      return {
        ...state,
        isExpotingData: false
      };
    case transactionHistoryTypes.EXPORT_TRANSACTION_FAILURE:
      return {
        ...state,
        isExpotingData: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default transactionHistoryReducer;
